import {Injectable} from '@angular/core';
import {User} from "./shared/forms/models/constants";
import {Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    currentUser$: Subject<User> = new Subject();
    currentUser!: User;
}
